<template>
<section class="section-search-results">
  <div class="container xl">
    <div class="columns is-multiline is-mobile justify-content-between">
      <div class="column is-12-mobile is-4-tablet is-3-desktop is-3-widescreen hide-sm">
        <div class="columns is-mobile">
          <div class="column">
            <skeleton
              type="rect"
              :width="'100%'"
              :height="'400px'"
            />
          </div>
        </div>
      </div>

      <div class="column is-12-mobile is-8-tablet is-9-desktop is-9-widescreen">
        <div class="mt15 store-cat-items">
     
          <div class="columns mb0 is-multiline is-variable is-1-tablet" v-if="vg_storeItemDisplayType == 'grid'">
            <skeleton-item v-for="i in 8" v-bind:key="'ske-item-'+i" />
          </div>
          <div class="columns mb0 is-multiline is-variable is-1-tablet" v-if="vg_storeItemDisplayType == 'list'">
            <skeleton-item-list v-for="i in 6" v-bind:key="'ske-item-'+i" />
          </div>
         
        </div>
      </div>

    </div>
  </div>
</section>
</template>

<script>
import SkeletonItem from './SkeletonItem.vue';
import SkeletonItemList from './SkeletonItemList.vue';
import { mapGetters } from "vuex";
export default {
  name: "StoreProfileSkeleton",
  components: {
    SkeletonItem,
    SkeletonItemList,
  },
  computed: {
    ...mapGetters({
      vg_storeItemDisplayType: "storeprofile/itemDisplayType",
    })
  },
}
</script>